import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BrandSplash } from "./BrandSplash";

function Loading() {
  return <BrandSplash text="Signing you in…" />;
}

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const state = useMemo(() => ({ from: loc.pathname }), [loc.pathname]);
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" state={state} replace />;
  if (user.must_change_password && loc.pathname !== "/set-password") return <Navigate to="/set-password" replace />;
  return children;
}

export function OfficerRoute({ children }) {
  const { user, isOfficer } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/set-password" replace />;
  if (!isOfficer) return <Navigate to="/portal" replace />;
  return children;
}

export function PermRoute({ perm, children }) {
  const { can } = useAuth();
  if (!can(perm)) return <Navigate to="/admin" replace />;
  return children;
}
